import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from '../../../elements/field-error/field-error';
import { PlusIcon, TrashIcon } from '@heroicons/react/outline';
import { Button } from '../../../elements/button';
import { AddTree } from '../../../../assets/icons/AddTree';
import { Select } from '../../../elements/select';
import { RadioGroup } from '../../../elements/radio-group';
import { Toggle } from '../../../elements/toggle';

// construccion del objeto yup de validacion del cuestionario
let obligado = {
    name: Yup.string().required('obligatorio'),
    email: Yup.string().email('must-be-email').nullable(),
    code: Yup.string().required('obligatorio'),

};
const validacion = Yup.object().shape(obligado);

const initialValues = {
    name: '',
    address: '',
    country: null,
    zip_code: '',
    residence_type_code: '',
    city: '',
    phone_number: ''
};

export const ProviderForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    // console.log('USUARIOS FORM :: EDIT ITEM', item);

    const { t } = useTranslation();
    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);
    const [countries, setCountries] = useState<any | null>([]);

    useEffect(() => {
        api('/fleet/countries/?limit=9999', 'GET');
    }, []);

    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);



        if (enviaremos.id) {
            // update

            api(`/fleet/vehicle-providers/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/vehicle-providers/', 'POST', enviaremos);
        }
    };


    useEffect(() => {
        if (state.data) {
            if (state.path.includes('vehicle-providers')) {
                if (state.method === 'POST') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                } else if (state.method === 'GET') {
                } else if (state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
            if (state.path.includes('countries')) {
                setCountries(state.data.results);
            }
        }

        if (state.error) {
            if (state.error.name) {
                if (state.error.name[0] == 'Ya existe vehicle provider con este name.') {
                    toast.error(`${t('common.form-label.proveedor-vehicle-error-name')}`);
                }

            } else if (state.error.code) {
                if (state.error.code[0] == 'Ya existe vehicle provider con este code.') {
                    toast.error(`${t('common.form-label.proveedor-vehicle-error-code')}`);
                }
            } else {
                toast.error('Server Error');
                //toast.error(`${t('common.error.server-or-network')}`);
            }

        }
    }, [state]);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={data || initialValues}
            validationSchema={validacion}
            validateOnBlur={true}
            onSubmit={onSubmit}
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">
                    <div className="pb-8">
                        <Input
                            name="code"
                            label={t('common.label.codigo')}
                            type="text"
                            placeholder={t('common.label.codigo')}
                            value={data?.code || values.code}
                            onChange={(value) => {
                                setFieldValue('code', value.code);
                            }}
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'code'}
                        />
                        <Input
                            label={t('common.form-label.name')}
                            type="text"
                            placeholder={t('common.form-label.name')}
                            name="name"
                            value={values.name}
                            onChange={(value) =>
                                setFieldValue('name', value.name)
                            }
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'name'}
                        />

                        <Input
                            label={t('usuario.form.email')}
                            type="text"
                            placeholder={t('usuario.form.email')}
                            name="email"
                            value={values.email}
                            onChange={(value) =>
                                setFieldValue('email', value.email)
                            }
                        />
                        <FieldError touched={touched} errors={errors} field={"email"} />

                        <Input
                            label={t('common.form-label.phone')}
                            type="text"
                            placeholder={t('common.form-label.phone')}
                            name="phone_number"
                            value={values.phone_number}
                            onChange={(value) =>
                                setFieldValue('phone_number', value.phone_number)
                            }
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'phone_number'}
                        />

                        <Input
                            label={t('common.form-label.address')}
                            type="text"
                            placeholder={t('common.form-label.address')}
                            name="address"
                            value={values.address}
                            onChange={(value) =>
                                setFieldValue('address', value.address)
                            }
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'address'}
                        />

                        <div className="flex justify-between">
                            <div className="w-full">
                                <Input
                                    label={t('common.form-label.ciudad')}
                                    type="text"
                                    placeholder={t('common.form-label.ciudad')}
                                    name="city"
                                    value={values.city}
                                    onChange={(value) =>
                                        setFieldValue('city', value.city)
                                    }
                                />
                                <FieldError
                                    touched={touched}
                                    errors={errors}
                                    field={'city'}
                                />
                            </div>

                            <div className="w-full pl-4">
                                <Input
                                    label={t('common.label.codigo-postal')}
                                    type="text"
                                    placeholder={t(
                                        'common.label.codigo-postal'
                                    )}
                                    name="zip_code"
                                    value={values.zip_code}
                                    onChange={(value) =>
                                        setFieldValue(
                                            'zip_code',
                                            value.zip_code
                                        )
                                    }
                                />
                                <FieldError
                                    touched={touched}
                                    errors={errors}
                                    field={'zip_code'}
                                />
                            </div>
                        </div>

                        <Select
                            name="country"
                            label={t('common.label.country')}
                            placeholder="Select value"
                            items={countries}
                            value={values.country}
                            onChange={(value) =>
                                setFieldValue('country', value.country)
                            }
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'country'}
                        />


                        <div className='h-8'></div>


                        <Toggle
                            label={t('Renting')}
                            hasInfo
                            value={values.is_renting}
                            onChange={(value: any) =>
                                setFieldValue('is_renting', value.toggle)
                            }
                        />

                        <Toggle
                            label={t('Leasing')}
                            hasInfo
                            value={values.is_leasing}
                            onChange={(value: any) =>
                                setFieldValue('is_leasing', value.toggle)
                            }
                        />

                        <Toggle
                            label={t('common.label.propriedad')}
                            hasInfo
                            value={values.is_privately_owned}
                            onChange={(value: any) =>
                                setFieldValue('is_privately_owned', value.toggle)
                            }
                        />

                        <div className='h-24'></div>

                        <FormFooter
                            item={item}
                            doDelete={doDelete}
                            doSubmit={handleSubmit}
                            close={close}
                        />
                    </div>
                </form>
            )}
        </Formik>
    );
};
